"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAArtikeltyp = void 0;
/**
 * The supported iPro-`IAArtikeltyp`
 */
var IAArtikeltyp;
(function (IAArtikeltyp) {
    IAArtikeltyp[IAArtikeltyp["Trennsteg"] = 2100] = "Trennsteg";
    IAArtikeltyp[IAArtikeltyp["TrennstegGeschlitzt"] = 2110] = "TrennstegGeschlitzt";
    IAArtikeltyp[IAArtikeltyp["TrennstegAsymetrisch"] = 2120] = "TrennstegAsymetrisch";
    IAArtikeltyp[IAArtikeltyp["Rasttrennsteg"] = 2130] = "Rasttrennsteg";
    IAArtikeltyp[IAArtikeltyp["TrennstegMitZwischenboden"] = 2140] = "TrennstegMitZwischenboden";
    IAArtikeltyp[IAArtikeltyp["Klemmtrennsteg"] = 2150] = "Klemmtrennsteg";
    IAArtikeltyp[IAArtikeltyp["KlemmtrennstegAsymetrisch"] = 2160] = "KlemmtrennstegAsymetrisch";
    IAArtikeltyp[IAArtikeltyp["TrennstegFuerMitteloeffnungsteg"] = 2170] = "TrennstegFuerMitteloeffnungsteg";
    IAArtikeltyp[IAArtikeltyp["Zugentlastungstrennsteg"] = 2180] = "Zugentlastungstrennsteg";
    IAArtikeltyp[IAArtikeltyp["Seitenplatte"] = 2200] = "Seitenplatte";
    IAArtikeltyp[IAArtikeltyp["Teilungssteg"] = 2300] = "Teilungssteg";
    IAArtikeltyp[IAArtikeltyp["Hoehenschlitzsteg"] = 2310] = "Hoehenschlitzsteg";
    IAArtikeltyp[IAArtikeltyp["HoehenschlitzstegOffen"] = 2320] = "HoehenschlitzstegOffen";
    IAArtikeltyp[IAArtikeltyp["KlemmtrennstegHoehenschlitz"] = 2330] = "KlemmtrennstegHoehenschlitz";
    IAArtikeltyp[IAArtikeltyp["Klemmteilungssteg"] = 2340] = "Klemmteilungssteg";
    IAArtikeltyp[IAArtikeltyp["Universalsteg"] = 2350] = "Universalsteg";
    IAArtikeltyp[IAArtikeltyp["Universalraststeg"] = 2360] = "Universalraststeg";
    IAArtikeltyp[IAArtikeltyp["Einsteckboden"] = 2400] = "Einsteckboden";
    IAArtikeltyp[IAArtikeltyp["Fachboden"] = 2500] = "Fachboden";
    IAArtikeltyp[IAArtikeltyp["Universalboden"] = 2510] = "Universalboden";
    IAArtikeltyp[IAArtikeltyp["Zwischenboden"] = 2600] = "Zwischenboden";
    IAArtikeltyp[IAArtikeltyp["Abstandhalter"] = 2700] = "Abstandhalter";
    IAArtikeltyp[IAArtikeltyp["Rollenclip"] = 2810] = "Rollenclip";
    IAArtikeltyp[IAArtikeltyp["Zwischenlasche"] = 9999] = "Zwischenlasche";
    IAArtikeltyp[IAArtikeltyp["KlemmRasttrennsteg"] = 30220] = "KlemmRasttrennsteg";
    IAArtikeltyp[IAArtikeltyp["UniversalSeparator"] = 2355] = "UniversalSeparator";
    IAArtikeltyp[IAArtikeltyp["SmartPlasticsSeparator"] = 30230] = "SmartPlasticsSeparator";
})(IAArtikeltyp = exports.IAArtikeltyp || (exports.IAArtikeltyp = {}));
//# sourceMappingURL=IAArtikeltypEnum.js.map